import { render, staticRenderFns } from "./CompetitionFilterModal.vue?vue&type=template&id=b0879210&scoped=true"
import script from "./CompetitionFilterModal.vue?vue&type=script&lang=js"
export * from "./CompetitionFilterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0879210",
  null
  
)

export default component.exports